import { TableHideIcon } from 'common/customIcons/tableHide';
import { useState } from 'react';
import './FilterColumn.scss';
const FilterColumn = ({ children }: any) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="filterColumnWrapper"
      onClick={(e) => {
        e?.stopPropagation();
      }}
    >
      <div className="filterColumn">
        <div
          className="filterButton"
          onClick={() => {
            setShow(!show);
          }}
        >
          <div className="flex items-center">
            <TableHideIcon /> <p className="pl-1">Column</p>
          </div>
        </div>
        <div
          className={`backdrop ${show ? '' : 'hidden'}`}
          onClick={() => {
            setShow(false);
          }}
        ></div>
        <div className={`headerList ${show ? 'show' : 'hide'}`}>{children}</div>
      </div>
    </div>
  );
};

export default FilterColumn;
